import { z } from 'zod'

export const CRM_INGEST_CONTRACT_VERSION = '1.0.0' as const

/** Ingest projections are source-specific and intentionally passthrough. */
export const crmIngestResponseSchema = z.object({
  contract_version: z.literal(CRM_INGEST_CONTRACT_VERSION),
}).passthrough()

export type CrmIngestResponse = z.infer<typeof crmIngestResponseSchema>
